<template>
  <mdn-modal
      md
      hideFooterStart
      v-if="isModalOpen"
      @close-modal="close()"
      >
      <mdn-heading :level="1" size="md" slot="modal-header">{{ title }}</mdn-heading>

      <div slot="modal-body" class="flex flex-col gap-5">
        <mdn-heading :level="2">{{ bodyTitle }}</mdn-heading>

        <div :key="index" v-for="(text, index) in textsBody" class="flex flex-col gap-3">
          <div class="flex flex-row justify-start items-start align-top gap-2">
            <span class="mdn-Icon-check mdn-Icon--md"></span>
            <mdn-text :name="index">{{text.mainText}}</mdn-text>
          </div>

          <div :key="index" v-for="(item, index) in text.items" class="pl-10">
            <mdn-heading :name="index" :level="3">{{item.titleItems}}</mdn-heading>
            <mdn-text :key="i" v-for="(x, i) in item.itemsOpt">{{x}}</mdn-text>
          </div>
        </div>

        <div v-if="includedApps">
          <mdn-text class="font-bold pb-2 uppercase">{{ includedApps.title }}</mdn-text>
          <div class="flex flex-col gap-3">
            <div :key="index" v-for="(app, index) in includedApps.apps" class="flex flex-col">
                <mdn-text class="font-bold">{{app.name}}</mdn-text>
                <mdn-text class="ml-2">{{app.description}}</mdn-text>
            </div>
          </div>
        </div>

        <div v-if="limitedApps">
          <mdn-text class="font-bold pb-2 uppercase">{{ limitedApps.title }}</mdn-text>
          <div class="flex flex-col gap-3">
            <div :key="index" v-for="(app, index) in limitedApps.apps">
              <mdn-text class="font-bold">{{app.name}}</mdn-text>
              <mdn-text class="ml-2">{{app.description}}</mdn-text>
            </div>
          </div>
        </div>

      </div>
    </mdn-modal>

</template>

<script>
import { MdnModal, MdnText, MdnHeading } from 'mondrian-vue'

export default {
  name: 'OfferDialog',
  components: { MdnModal, MdnText, MdnHeading },
  data: () => ({
    title: '',
    bodyTitle: '',
    textsBody: '',
    includedApps: '',
    isModalOpen: false,
    limitedApps: ''
  }),
  methods: {
    show (opts = {}) {
      this.title = opts.title
      this.bodyTitle = opts.bodyTitle
      this.textsBody = opts.textsBody
      this.includedApps = opts.includedApps
      this.isModalOpen = true
      this.limitedApps = opts.limitedApps
    },
    close () {
      this.isModalOpen = false
    }
  }
}

</script>
